"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Simple = void 0;

var _react = _interopRequireDefault(require("react"));

var _styles = require("./styles");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

var Simple = function Simple(_ref) {
  var id = _ref.id,
      colorMode = _ref.colorMode,
      backgroundColor = _ref.backgroundColor,
      children = _ref.children;
  return _react.default.createElement(_styles.Section, {
    id: id,
    colorMode: colorMode,
    backgroundColor: backgroundColor === null || backgroundColor === void 0 ? void 0 : backgroundColor.hex
  }, children);
};

exports.Simple = Simple;